export default __webpack_public_path__ + "static/media/forms header.f98d1938.jpg";